import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountUnderReviewComponent } from './account-under-review.component';
import { ButtonModule } from '../shared/components/button/button.module';
import { RouterModule } from '@angular/router';


const routes = [
  {
    path: '', component: AccountUnderReviewComponent,
    children: [],
  },
];
@NgModule({
  declarations: [AccountUnderReviewComponent],
  imports: [
    CommonModule,
    ButtonModule,
    RouterModule.forChild(routes)
  ]
,
exports: [AccountUnderReviewComponent]
})
export class AccountUnderReviewModule { }
